import { render, staticRenderFns } from "./live-list.vue?vue&type=template&id=13c2f5cf&scoped=true&"
import script from "./live-list.vue?vue&type=script&lang=js&"
export * from "./live-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2f5cf",
  null
  
)

export default component.exports